import React from 'react';

import Spinner from '@/components/Loading';

interface Props {
  height?: string;
  width?: string;
}

export default function MiniSpinner(props: Props): React.JSX.Element {
  const { height = 6, width = 8 } = props;
  return (
    <div className={`flex justify-center items-center h-${height} w-${width}`}>
      <Spinner />
    </div>
  );
}
